import { SIGNUP } from "@/shared/constants/routes";
import { Text } from "@orgmym/leeloo-core";
import { useTranslation } from "react-i18next";

import { Link } from "@/shared/components/link/Link";

export const SignupLink = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <Text centered {...props}>
      {t("doesnt_have_an_account")}&nbsp;<Link to={SIGNUP}>{t("signup")}</Link>
    </Text>
  );
};
